import type { ReactElement } from 'react';

export interface AuthInitErrorProps {
  /** Текст или объект ошибки init Keycloak */
  error: Error | null;
}

/**
 * Экран ошибки инициализации Keycloak (неверные env, сеть, bootstrap auth).
 *
 * @param {AuthInitErrorProps} props — пропсы
 * @returns {ReactElement}
 */
export function AuthInitError({ error }: AuthInitErrorProps): ReactElement {
  const message = error !== null ? error.message : 'Не удалось инициализировать авторизацию';
  return (
    <main className='app-shell'>
      <h1 className='app-shell__title'>Ошибка входа</h1>
      <p className='app-shell__hint'>{message}</p>
    </main>
  );
}
